export default "__VITE_ASSET__Dld3khh3__"